import { DetailsHeader, Segments } from "components";
import { Route, Routes, Navigate } from "react-router";
import PacksReport from "../Pack/PacksReport";
import { RouteNames } from "enums";
import AddOnsReport from "features/Reporting/AddOns/AddOnsReport";
import { useMemo } from "react";
import type { RootState } from "features/Application/globaltypes/redux";
import { connect, type ConnectedProps } from "react-redux";
import { useCanViewAddonsReport } from "features/Reporting/AddOns/hooks/useCanViewAddonsReport";

export type Props = PropsFromRedux;

export const PacksLicensingSegments = ({ accountId }: Props) => {
  const canViewAddOnsReport = useCanViewAddonsReport(accountId);

  const pages = useMemo(() => {
    const base = [
      {
        to: "",
        label: "Packs",
      },
    ];
    if (canViewAddOnsReport) {
      base.push({
        to: "addOns",
        label: "Add-Ons",
      });
    }
    return base;
  }, [canViewAddOnsReport]);

  return (
    <>
      <DetailsHeader title={canViewAddOnsReport ? "Packs & Add-Ons" : "Packs & Licensing"} showReportLastUpdated />
      <Segments to={`/${RouteNames.reportingPacks}`}>
        {pages.map((page) => (
          <Segments.Segment key={page.label} {...page} />
        ))}
      </Segments>
      <div className="scrollable-content">
        <Routes>
          <Route path="" element={<PacksReport />} />
          {canViewAddOnsReport && <Route path="addOns" element={<AddOnsReport />} />}
          <Route path="*" element={<Navigate to={`/${RouteNames.reportingPacks}`} replace />} />
        </Routes>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  accountId: state.userProfile.accountId,
});

const connector = connect(mapStateToProps, null);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(PacksLicensingSegments);
export default ConnectedComponent;
